import { RoutablePage, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { COREX_GRACE_PERIOD_QUERY, USER_PENDING_QUESTIONNAIRES_QUERY, AML_ID_AND_ADDRESS_VERIFIED } from '@gig/magic-messages';

var GracePeriodModal = /** @class */ (function (_super) {
    __extends(GracePeriodModal, _super);
    function GracePeriodModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.daysRemaining = 0;
        _this.amlStatus = null;
        return _this;
    }
    GracePeriodModal.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var restriction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(COREX_GRACE_PERIOD_QUERY)];
                    case 1:
                        restriction = _a.sent();
                        this.calculateDaysRemaining(restriction.startsOn);
                        return [2 /*return*/];
                }
            });
        });
    };
    GracePeriodModal.prototype.verify = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isApproved, hasPendingQuestionnaires;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(AML_ID_AND_ADDRESS_VERIFIED)];
                    case 1:
                        isApproved = _a.sent();
                        if (!!isApproved) return [3 /*break*/, 2];
                        this.routeTo({ route: RoutablePage.VERIFICATION });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, window.queryBus.query(USER_PENDING_QUESTIONNAIRES_QUERY)];
                    case 3:
                        hasPendingQuestionnaires = _a.sent();
                        if (hasPendingQuestionnaires) {
                            this.routeTo({ route: RoutablePage.QUESTIONNAIRES });
                        }
                        else {
                            this.routeTo({ route: RoutablePage.VERIFICATION });
                        }
                        _a.label = 4;
                    case 4:
                        this.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    GracePeriodModal.prototype.calculateDaysRemaining = function (startsOn) {
        var targetDate = new Date(startsOn);
        var currentDate = new Date();
        var msPerDay = 24 * 60 * 60 * 1000;
        var timeDifference = targetDate.getTime() - currentDate.getTime();
        this.daysRemaining = Math.ceil(timeDifference / msPerDay);
        if (targetDate > currentDate) {
            this.daysRemaining = Math.ceil(timeDifference / msPerDay);
        }
        else {
            this.daysRemaining = 0;
        }
        return this.daysRemaining;
    };
    Object.defineProperty(GracePeriodModal.prototype, "digitOne", {
        get: function () {
            return Math.floor(this.daysRemaining / 10);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GracePeriodModal.prototype, "digitTwo", {
        get: function () {
            return this.daysRemaining % 10;
        },
        enumerable: false,
        configurable: true
    });
    GracePeriodModal.prototype.close = function () {
        this.$emit('close');
    };
    GracePeriodModal = __decorate([
        Component({
            name: 'corex-grace-period-modal',
        })
    ], GracePeriodModal);
    return GracePeriodModal;
}(Mixins(MagicConfigMixin)));

export default GracePeriodModal;
